<template>
  <div>
    <vue-tags-input
      v-model="tag"
      :tags="tags"
      :autocomplete-items="autocompleteItems"
      :add-only-from-autocomplete="true"
      @tags-changed="update"
    />
  </div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  components: {
    VueTagsInput,
  },
  data() {
    return {
      tag: '',
      tags: [],
      autocompleteItems: [],
      debounce: null,
    };
  },
  mounted() {
    this.getExistingTags();
  },
  watch: {
    tag: 'initItems',
  },
  methods: {
    update(newTags) {
    /** const url = 'Tagsimagenes/deleteTags/1';
      const url2 = 'Tagsimagenes/saveTag';

      this.loading = true;
      this.axios.get(url);
      this.loading = false;

      newTags.forEach((a) => {
        this.axios.post(url2, { id: a.key, idimg: 1 });
        console.log(a.text);
      }); */

      this.autocompleteItems = [];
      this.tags = newTags;
    },
    initItems() {
      const url = 'Tags';
      const datos = [];


      this.axios.get(url).then((res) => {
        res.data.forEach((a) => {
          datos.push({ text: a.NOMBRE, key: a.ID });
        });
        this.autocompleteItems = datos;
      })
        .catch((error) => {
          console.error(error);
        });
      this.loading = false;
    },
    async getExistingTags() {
      const url = 'Tagsimagenes/findByimage/1';
      const datos = [];

      this.loading = true;
      try {
        this.axios.get(url).then((res) => {
          res.data.forEach((a) => {
            datos.push({ text: a.NOMBRE, key: a.ID });
          });
          this.tags = datos;
        })
          .catch((error) => {
            console.error(error);
          });
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
  },
};
</script>
